import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from "@angular/core";
import { RenderedService } from "../../rendered.service";
import { FileModalComponent } from "@scaffold/dialogs/file-modal/file-modal.component";
import { ItemsService } from "@scaffold/services/items.service";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";
import { NbDialogService, NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "scaffold-file-image",
  templateUrl: "./file-image.component.html",
  styleUrls: ["../../rendered.component.scss", "./file-image.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileImageComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  @Output() change = new EventEmitter<any>();

  dialogRef: NbDialogRef<FileModalComponent>;
  public destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    public dialog: NbDialogService,
    private itemsService: ItemsService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((trigger) => {
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  clearFile() {
    this.change.emit({ value: null });
  }

  selectFile(item, param, filter): void {
    console.log(item);
    let settings: any = {
      context: {
        data: {
          filter: filter || "",
        },
      },
    };
    this.dialogRef = this.dialog.open(FileModalComponent, settings);

    this.dialogRef.onClose.subscribe((result) => {
      console.log(result);
      if (result && typeof result !== "string") {
        // this.data[param] = "/files/" + result.id;
        if (this.info) {
          this.change.emit({ value: result.id });
          // TODO - sendUpdate
          // this.sendUpdate(param, "/files/" + result.id, this.info);
        }
        item["file_data"] = result.data;
      }
    });
  }
}
